export default __webpack_public_path__ + "static/media/feraye2.80d5986a.jpg";